import React, { useState } from 'react';
import { doctorsAPI } from '../../services/api';
import { ModernInput, ModernButton } from '../ui/ModernComponents';
import { User, Phone, Mail, MapPin, Save, X, Stethoscope } from 'lucide-react';
import toast from 'react-hot-toast';

const defaultForm = {
  name: '',
  contact: '',
  phone: '',
  address: '',
};

function AddDoctorForm({ onSuccess, onCancel }) {
  const [form, setForm] = useState(defaultForm);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(f => ({ ...f, [name]: value }));
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const res = await doctorsAPI.createDoctor(form);
      toast.success('Médecin ajouté');
      setForm(defaultForm);
      if (onSuccess) onSuccess(res.data);
    } catch (err) {
      toast.error('Erreur lors de la sauvegarde');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-6">
      <div className="space-y-4">
        <div>
          <label className="block text-base font-semibold text-gray-800 mb-1">Nom du médecin</label>
          <ModernInput
            name="name"
            value={form.name}
            onChange={handleChange}
            placeholder="Ex: Dr. Jean Dupont"
            icon={<Stethoscope className="w-5 h-5" />}
            required
            className="w-full"
          />
        </div>
        <div>
          <label className="block text-base font-semibold text-gray-800 mb-1">Contact</label>
          <ModernInput
            name="contact"
            value={form.contact}
            onChange={handleChange}
            placeholder="Ex: contact@medecin.com"
            icon={<Mail className="w-5 h-5" />}
            className="w-full"
          />
        </div>
        <div>
          <label className="block text-base font-semibold text-gray-800 mb-1">Téléphone</label>
          <ModernInput
            name="phone"
            value={form.phone}
            onChange={handleChange}
            placeholder="Ex: +33 1 23 45 67 89"
            icon={<Phone className="w-5 h-5" />}
            className="w-full"
          />
        </div>
        <div>
          <label className="block text-base font-semibold text-gray-800 mb-1">Adresse</label>
          <ModernInput
            name="address"
            value={form.address}
            onChange={handleChange}
            placeholder="Ex: 123 Rue de la Paix, Paris"
            icon={<MapPin className="w-5 h-5" />}
            className="w-full"
          />
        </div>
      </div>
      <div className="flex justify-end space-x-2 pt-2">
        <ModernButton type="button" variant="secondary" onClick={onCancel} icon={<X className="w-4 h-4" />}>
          Annuler
        </ModernButton>
        <ModernButton type="button" variant="primary" icon={<Save className="w-4 h-4" />} disabled={loading} onClick={handleSubmit}>
          {loading ? 'Ajout...' : 'Ajouter'}
        </ModernButton>
      </div>
    </div>
  );
}

export default AddDoctorForm; 